module.exports = __webpack_public_path__ + "static/media/alert-orange-icon.8237658f.svg";